/* eslint-disable no-lone-blocks */
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Button from "@mui/material/Button";
import {
  Box,
  Dialog,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import { useEffect, useMemo, useState } from "react";
import { fAlertToast } from "../../../Utility/Utilitys";
import moment from "moment";
import { GET_API_RSP_Change_Request_Basket_Update } from "../../../Server/ApiV2";

const PromotionAutocomplete = ({
  xValue,
  xOpen,
  xCloseModal,
  xHeadSelectedLoc,
  getBasketRows,
  xModalfullScreen = false,
  xModalHeight,
  vMediaQuery,
  xOnChange = () => {},
  xOnKeyUp = () => {},
  xonClickbtn = () => {},
  xRows = [],
  xRowsOrginal = [],
  updateRows= () => {},
  xRowClick = () => {},
  xLocation,
  xtabIndex,
  xOnKeyDown = () => {},
  initialState
}) => {

  let initialform = {
    P_PromoId: 0,
    P_FromDate: moment().startOf("month").toDate(),
    P_ToDate: moment().toDate(),
    P_Loc: xHeadSelectedLoc,
    P_Narration: "",
  };

  const [formData, setFormData] = useState(initialform);

  const toolbar = {
    backgroundColor: "#0d73bb",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    minHeight: "40px !important",
  };

  const columns = [
    {
      field: "",
      headerName: "Edit",
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <EditIcon
            onClick={(e) => {
              e?.stopPropagation();
              setFormData((prev) => ({
                ...prev,
                P_PromoId: params?.row?.PromoId,
                P_FromDate: params?.row?.FromDate,
                P_ToDate: params?.row?.ToDate,
                P_Loc: params?.row?.Loc?.split(","),
                P_Narration: params?.row?.Narration,
              }));
            }}
          />
        );
      },
    },
    {
      field: "PromoId",
      headerName: "Promo Id",
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "LocName",
      headerName: "Locations",
      width: vMediaQuery && 200,
      flex: vMediaQuery ? 0 : 1,
      headerAlign: "center",
    },
    {
      field: "Narration",
      headerName: "Name",
      width: 200,
      headerAlign: "center",
    },
    {
      field: "Status",
      headerName: "Status",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleSave = async () => {
    try {
      if (formData?.P_Loc.length === 0) {
        fAlertToast("FAILED", "need to select atleast one location");
        return;
      }
            if (!formData?.P_Narration) {
        fAlertToast("FAILED", "Promotion narration should not be empty");
        return;
      }
      const res = await GET_API_RSP_Change_Request_Basket_Update({
        ...formData,
        P_FromDate: moment(formData?.P_FromDate).format("MM/DD/YYYY"),
        P_ToDate: moment(formData?.P_ToDate).format("MM/DD/YYYY"),
        P_Loc: formData?.P_Loc?.toString(),
      });
      if (res?.status === 200) {
        if (initialState) {
          setFormData((prev) => ({
            ...prev,
            ...initialState,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            ...initialform,
          }));
        }
        getBasketRows();
      }
    } catch (error) {}
  };

  const handleNew = () => {
    setFormData((prev) => ({
      ...prev,
      ...initialform,
    }));
  };

  const fClose = () => {
    setFormData(initialform);
    xCloseModal();
  };


const filteredRows = useMemo(() => {
  const src = xRowsOrginal ?? [];
  const val = (xValue ?? "").toString();
  if (!val) return src;

  if (initialState?.P_PromoId) {
    return src.filter((r) => String(r?.PromoId ?? "") === val);
  } else {
    const q = val.toLowerCase();
    return src.filter((r) => r.Narration?.toLowerCase().startsWith(q));
  }
  }, [xRowsOrginal, xValue, initialState?.P_PromoId]);

useEffect(() => {
  updateRows(filteredRows);
}, [filteredRows, updateRows]);

useEffect(() => {
  setFormData(prev => ({
    ...prev,
    P_Loc: Array.isArray(xHeadSelectedLoc) ? xHeadSelectedLoc : [],
  }));
}, [xHeadSelectedLoc]);

// load initialState once (or when a key field changes)
useEffect(() => {
  if (initialState) {
    setFormData(prev => ({
      ...prev,
      ...initialState,
    }));
  }
}, [initialState]);


  return (
    <>
      {!initialState && (
        <div className="d-flex ">
          <TextField
            size="small"
            variant="outlined"
            fullWidth
            value={xValue ?? ""}
            onChange={(e) => xOnChange?.(e.target.value, e)}
            onKeyUp={xOnKeyUp}
            autoComplete="off"
            tabIndex={xtabIndex}
            onKeyDown={xOnKeyDown}
          />

          <Button
            onClick={xonClickbtn}
            variant="outlined"
            className="btn-text-transform-none"
            sx={{
              minWidth: "40px",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            }}
          >
            <MoreHorizIcon fontSize="small" />
          </Button>
        </div>
      )}
      <Dialog
        open={xOpen}
        onClose={fClose}
        maxWidth={"md"}
        fullScreen={xModalfullScreen}
      >
        <Paper
          style={{
            height: xModalHeight,
          }}
        >
          <Toolbar sx={toolbar}>
            <span>&nbsp;</span>
            <DialogTitle
              sx={{
                backgroundColor: "#0d73bb",
                color: "white",
                padding: "0 4px !important",
              }}
            >
              Promotion Basket Modal
            </DialogTitle>
            <IconButton
              edge="end"
              color="inherit"
              onClick={fClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <DialogContent
            sx={{
              overflowX: "hidden",
              overflowY: "auto",
              padding: "1rem !important",
            }}
          >
            <Grid container spacing={2}>
              {/* ID */}
              <Grid item xs={3} sm={2} md={1.5}>
                {/* <Typography>ID</Typography> */}
                <TextField
                  type="number"
                  size="small"
                  label="Id"
                  value={formData?.P_PromoId}
                  disabled={true}
                  sx={{
                    bgcolor: "lightgray",
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={4.5} sm={5} md={2}>
                <CmpDatePickerField001V1
                  xLabelText="From Date"
                  xValue={formData?.P_FromDate}
                  xOnChange={(newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      P_FromDate: newValue.$d,
                    }));
                  }}
                  xError={false}
                />
              </Grid>
              <Grid item xs={4.5} sm={5} md={2}>
                <CmpDatePickerField001V1
                  xLabelText="To Date"
                  xValue={formData?.P_ToDate}
                  xOnChange={(newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      P_ToDate: newValue.$d,
                    }));
                  }}
                   xError={false}
                />
              </Grid>
              {/* Location Multi-select */}
              <Grid item xs={12} sm={6} md={6.5}>
                <GCAutocompleteCheckboxFixSizeUid
                  label="Location"
                  xValue={formData?.P_Loc}
                  setValue={(updated) => {
                    setFormData((prev) => ({
                      ...prev,
                      P_Loc: updated,
                    }));
                  }}
                  options={xLocation ?? []}
                  // objName="P_Loc"
                  placeholder="Search Location"
                />
              </Grid>
              {/* Narration */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  size="small"
                  label={"Name"}
                  value={formData?.P_Narration}
                  name="A_Narration"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      P_Narration: e.target.value,
                    }))
                  }
                  fullWidth
                  autoComplete="off"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={8}>
                <Box
                  display="flex"
                  gap={2}
                  sx={{ justifyContent: "flex-end", flexWrap: "wrap" }}
                >
                  {/* New Button */}
                  {!initialState && (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleNew}
                    >
                      New
                    </Button>
                  )}

                  {/* Save Button */}
                  {!initialState && (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  )}

                  {/* Save Button */}
                  {initialState && initialState?.isActive && (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                mt: 2,
                height: { xs: "30vh", sm: "35vh", md: "36vh", lg: "40vh" },
              }}
            >
              <DataGridPro
                rowHeight={30}
                headerHeight={30}
                getRowId={(row) => row?.PromoId}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#0d73bb",
                    color: "white",
                    fontSize: "10px", // Font size for headers
                    padding: "0px !important", // Remove extra padding inside headers
                  },
                }}
                rows={xRows}
                columns={columns}
                onRowClick={xRowClick}
                hideFooter={true}
              />
            </Box>
          </DialogContent>
        </Paper>
      </Dialog>
    </>
  );
};

export default PromotionAutocomplete;
